import React, { useLayoutEffect, useRef, useState } from 'react';
import { FixedFooterLayoutProps } from './interface';
import { FixedFooter } from './InternalFixedFooter.web';
import { FixedTitle } from './InternalFixedTitle.web';

const useElementHeight = (): { height: number; ref: React.RefObject<HTMLDivElement> } => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const update = () => setHeight(element.getBoundingClientRect().height);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { height, ref };
};

export const FixedFooterLayout = ({ children, footerContent, title }: FixedFooterLayoutProps) => {
  const { height: footerHeight, ref: footerRef } = useElementHeight();

  return (
    <>
      {title && <FixedTitle>{title}</FixedTitle>}
      <div style={{ paddingBottom: `${footerHeight}px` }}>{children}</div>
      <FixedFooter ref={footerRef}>{footerContent}</FixedFooter>
    </>
  );
};
